/* eslint-disable */
"use strict";

import { ODUtil } from "./../../components/util.js";
import ODOffcanvas from "./../../components/offcanvas.js";

var ODLayoutQuickPanel = function() {
    // Private properties
    var _element;
    var _offcanvasObject;
    var _notificationsElement;
    var _logsElement;
    var _settingsElement;

    // Private functions
    var _getContentHeight = function() {
        var height;

        var header = ODUtil.find(_element, '.offcanvas-header');
        var content = ODUtil.find(_element, '.offcanvas-content');

        var height = parseInt(ODUtil.getViewPort().height);

        if (header) {
            height = height - parseInt(ODUtil.actualHeight(header));
            height = height - parseInt(ODUtil.css(header, 'marginTop'));
            height = height - parseInt(ODUtil.css(header, 'marginBottom'));
        }

        if (content) {
            height = height - parseInt(ODUtil.css(content, 'marginTop'));
            height = height - parseInt(ODUtil.css(content, 'marginBottom'));
        }

        height = height - parseInt(ODUtil.css(_element, 'paddingTop'));
        height = height - parseInt(ODUtil.css(_element, 'paddingBottom'));

        height = height - 2;

        return height;
    }

    var _init = function() {
        _offcanvasObject = new ODOffcanvas(_element, {
            overlay: true,
            baseClass: 'offcanvas',
            placement: 'right',
            closeBy: 'od_quick_panel_close',
            toggleBy: 'od_quick_panel_toggle'
        });
    }

    var _initNotifications = function() {
        ODUtil.scrollInit(_notificationsElement, {
            mobileNativeScroll: true,
            resetHeightOnDestroy: true,
            handleWindowResize: true,
            height: function() {
                return _getContentHeight();
            }
        });
    }

    var _initLogs = function() {
        ODUtil.scrollInit(_logsElement, {
            mobileNativeScroll: true,
            resetHeightOnDestroy: true,
            handleWindowResize: true,
            height: function() {
                return _getContentHeight();
            }
        });
    }

    var _initSettings = function() {
        ODUtil.scrollInit(_settingsElement, {
            mobileNativeScroll: true,
            resetHeightOnDestroy: true,
            handleWindowResize: true,
            height: function() {
                return _getContentHeight();
            }
        });
    }

    var _updateScrollbars = function() {
        $(_element).find('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            ODUtil.scrollUpdate(_notificationsElement);
            ODUtil.scrollUpdate(_logsElement);
            ODUtil.scrollUpdate(_settingsElement);
        });
    }

    // Public methods
    return {
        init: function(id) {
            _element = ODUtil.getById(id);
            _notificationsElement = ODUtil.getById('od_quick_panel_notifications');
            _logsElement = ODUtil.getById('od_quick_panel_logs');
            _settingsElement = ODUtil.getById('od_quick_panel_settings');

            _init();
            _initNotifications();
            _initLogs();
            _initSettings();

            
        }
    };
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = ODLayoutQuickPanel;
}

export default ODLayoutQuickPanel;
